import React from "react";
import ReportParameterGroupState from "./ReportParameterGroupState";
import LogoAndTotalScorePdf from "./LogoAndTotalScore";
const ReportParameterDetails = ({ dish }) => {
  return (
    <div className="flex flex-col w-full pt-4 break-inside-avoid print:pt-2">
      <div className="w-full p-2 break-inside-avoid print:p-1 print:px-0">
        <div className="text-center">
          <LogoAndTotalScorePdf dish={dish} />
          <ReportParameterGroupState dish={dish} />
        </div>
      </div>
    </div>
  );
};

export default ReportParameterDetails;